/**
 * Accordion component.
 * Animated opening and closing of accordion.
 * Opening one item will not close the other items.
 * Appears flat and usable when JS is disabled.
 *
 * Based on Inclusive Components: https://inclusive-components.design/collapsible-sections/
 *
 * Usage:
 * Call Accordion.init() to initialize all targets.
 *
 * Methods:
 *
 * init(): create accordion for all targets
 * initFor(): create accordion for one target
 */

const initFor = $el => {
	const $headings = $el.querySelectorAll('[data-accordion-heading]');
	const $bodys = $el.querySelectorAll('[data-accordion-body]');
	// Validate
	if ($headings.length === 0 || $headings.length !== $bodys.length) {
		return;
	}

	// Initiate
	$el.classList.add('is-active');

	// Vars and Functions
	const $buttons = [];
	const len = $headings.length;
	const expand = i => {
		$bodys[i].classList.add('is-open');
		$buttons[i].setAttribute('aria-expanded', true);
		$bodys[i].hidden = false;
	};
	const unexpand = i => {
		$bodys[i].classList.remove('is-open');
		$buttons[i].setAttribute('aria-expanded', false);
		$bodys[i].hidden = true;
	};

	const onClick = index => {
		const $btn = $buttons[index];
		// Cast the state as a boolean
		const expanded = $btn.getAttribute('aria-expanded') === 'true' || false;
		// Switch the state
		// Switch the content's visibility
		if (!expanded) {
			expand(index);
			current = index;
		} else {
			unexpand(index);
			current = null;
		}
	};

	const createAccordion = i => {
		const heading = $headings[i];
		const expanded = !!heading.getAttribute('data-accordion-expanded');

		// $headings.forEach((heading, index) => {
		// Give each <h2> a toggle button child
		// with the SVG plus/minus icon
		heading.innerHTML = `
			<button aria-expanded="false">
			  ${heading.innerHTML}
			</button>
		  `;

		// Assign the contents to be expanded/collapsed (array)
		const contents = $bodys[i];

		// Create a wrapper element for `contents` and hide it
		contents.hidden = true;

		// Assign the button
		const btn = heading.querySelector('button');
		$buttons.push(btn);

		btn.addEventListener('click', () => {
			onClick(i);
		});
	};

	// Create
	for (let i = 0; i < len; i += 1) {
		createAccordion(i);
	}

	for (let i = 0; i < len; i += 1) {
		const heading = $headings[i];
		const expanded = !!heading.getAttribute('data-accordion-expanded');

		if (expanded) {
			expand(i);
		}
	}
};

const init = () => {
	const $targets = document.querySelectorAll('.js-accordion');
	$targets.forEach($el => {
		initFor($el);
	});
};

module.exports = {
	init,
	initFor
};
